import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Employee } from "domain/entities/employee";
import { EmployeeInputFilter } from "../../domain/models/employee-input-filter";
import { Logger } from "../../infra/logger/logger";
import employeeRepository from "../../infra/repositories/employee-repository";
import { DistanceInputFilter } from "domain/models/distance-input-filter";
import distanceRepository from "infra/repositories/distance-repository";


export const useTripLocationsByFilter = (filter: DistanceInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["tripOrigins", filter],
    queryFn: async () => {
      try {
        const result = await distanceRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: Number(process.env.REACT_APP_QUERY_STALE_TIME_SHORT) || 0,
  });
};

